// // InventoryWithProfitLoss.js
// // reportsService.InventoryWithProfitLoss(recordset, data, mode)
// //
// // Assumes ExcelJS + file-saver (npm install exceljs file-saver).
// // Uses the same 2-layer column structure you already have for the grid
// // (2layerheadinginexcel) so the on-screen grid and the exported sheet stay in sync.

// import ExcelJS from 'exceljs';
// import { saveAs } from 'file-saver';

// // ---- Column definition (top group + sub columns) ----
// // Edit widths/labels here only — everything else derives from this.
// const reportColumns = [
//   { headerText: 'Item Name', field: 'ProductName', width: 28 },
//   { headerText: 'Opening', columns: [
//       { headerText: 'Qty.', field: 'OpQuantity', width: 11 },
//       { headerText: 'Rate', field: 'OpRate', width: 11 },
//       { headerText: 'Amt.', field: 'OpAmount', width: 13 },
//   ]},
//   { headerText: 'Purchase', columns: [
//       { headerText: 'Qty.', field: 'PurQuantity', width: 11 },
//       { headerText: 'Rate', field: 'PurRate', width: 11 },
//       { headerText: 'Amt.', field: 'PurAmount', width: 13 },
//   ]},
//   { headerText: 'Trans', columns: [
//       { headerText: 'Qty.', field: 'TransQuantity', width: 11 },
//   ]},
//   { headerText: 'Available', columns: [
//       { headerText: 'Qty.', field: 'AvailableQuantity', width: 11 },
//       { headerText: 'Rate', field: 'AvailableRate', width: 11 },
//       { headerText: 'Amt.', field: 'AvailableAmount', width: 13 },
//   ]},
//   { headerText: 'Closing Stock', columns: [
//       { headerText: 'Qty.', field: 'ClosingQuantity', width: 11 },
//       { headerText: 'Rate', field: 'ClosingRate', width: 11 },
//       { headerText: 'Amt.', field: 'ClosingAmount', width: 13 },
//   ]},
//   { headerText: 'Sale', columns: [
//       { headerText: 'Qty.', field: 'SaleQuantity', width: 11 },
//       { headerText: 'Rate', field: 'SaleAvgRate', width: 11 },
//       { headerText: 'Amt.', field: 'SaleAmount', width: 13 },
//   ]},
//   { headerText: 'Profit / Loss', columns: [
//       { headerText: 'Rate', field: 'SaleRateDiff', width: 11 },
//       { headerText: 'Amt.', field: 'profitLossAmt', width: 13 },
//   ]},
// ];

// // Flatten to the leaf (data-cell) columns, left to right
// const leafColumns = reportColumns.flatMap((col) =>
//   col.columns ? col.columns.map((c) => ({ ...c })) : [{ ...col }]
// );
// const TOTAL_COLS = leafColumns.length;

// const applyThinBorder = (cell) => {
//   cell.border = {
//     top: { style: 'thin' },
//     left: { style: 'thin' },
//     bottom: { style: 'thin' },
//     right: { style: 'thin' },
//   };
// };

// // Writes the two header rows (group row + sub row) starting at `groupRow`
// const writeHeaderBlock = (sheet, groupRow) => {
//   const subRow = groupRow + 1;
//   let col = 1;

//   reportColumns.forEach((group) => {
//     if (group.columns) {
//       const start = col;
//       const end = col + group.columns.length - 1;

//       sheet.mergeCells(groupRow, start, groupRow, end);
//       const groupCell = sheet.getCell(groupRow, start);
//       groupCell.value = group.headerText;
//       groupCell.font = { bold: true };
//       groupCell.alignment = { horizontal: 'center', vertical: 'middle' };

//       group.columns.forEach((sub, i) => {
//         const cell = sheet.getCell(subRow, start + i);
//         cell.value = sub.headerText;
//         cell.font = { bold: true };
//         cell.alignment = { horizontal: 'center' };
//       });
//       col = end + 1;
//     } else {
//       // Single column (e.g. Item Name) spans both header rows
//       sheet.mergeCells(groupRow, col, subRow, col);
//       const cell = sheet.getCell(groupRow, col);
//       cell.value = group.headerText;
//       cell.font = { bold: true };
//       cell.alignment = { horizontal: 'center', vertical: 'middle' };
//       col += 1;
//     }
//   });

//   [groupRow, subRow].forEach((r) =>
//     sheet.getRow(r).eachCell({ includeEmpty: true }, applyThinBorder)
//   );

//   return subRow; // last row used
// };

// const InventoryWithProfitLoss = async (recordset = [], data = {}, mode = 'download') => {
//   const workbook = new ExcelJS.Workbook();
//   const sheet = workbook.addWorksheet('Inventory With P&L');

//   // ---- Row 1: From / To date ----
//   sheet.mergeCells(1, 1, 1, TOTAL_COLS);
//   const dateCell = sheet.getCell(1, 1);
//   dateCell.value = `From Date : ${data.FromDate || ''}      To Date : ${data.ToDate || ''}`;
//   dateCell.font = { bold: true, size: 12 };
//   dateCell.alignment = { horizontal: 'center' };

//   // ---- Row 2: Report title ----
//   sheet.mergeCells(2, 1, 2, TOTAL_COLS);
//   const titleCell = sheet.getCell(2, 1);
//   titleCell.value = 'Inventory With Profit / Loss';
//   titleCell.font = { bold: true, size: 14 };
//   titleCell.alignment = { horizontal: 'center' };

//   // ---- Rows 3-4: two-layer column headers ----
//   const lastHeaderRow = writeHeaderBlock(sheet, 3);

//   // ---- Column widths ----
//   leafColumns.forEach((c, i) => {
//     sheet.getColumn(i + 1).width = c.width || 13;
//   });

//   // ---- Data rows ----
//   const dataStartRow = lastHeaderRow + 1;
//   recordset.forEach((item, rIdx) => {
//     const row = sheet.getRow(dataStartRow + rIdx);
//     leafColumns.forEach((col, cIdx) => {
//       const cell = row.getCell(cIdx + 1);
//       const raw = item[col.field];
//       if (col.field === 'ProductName') {
//         cell.value = raw ?? '';
//       } else {
//         cell.value = Number(raw || 0);
//         cell.numFmt = '#,##0';
//         cell.alignment = { horizontal: 'right' };
//       }
//     });
//   });

//   // ---- Repeat the heading at the bottom, as requested ----
//   const footerGroupRow = dataStartRow + recordset.length + 1; // blank row gap
//   writeHeaderBlock(sheet, footerGroupRow);

//   sheet.views = [{ state: 'frozen', ySplit: lastHeaderRow }];

//   if (mode !== 'download') {
//     // e.g. called for preview / to feed another step — return the workbook itself
//     return workbook;
//   }

//   const buffer = await workbook.xlsx.writeBuffer();
//   const blob = new Blob([buffer], {
//     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//   });
//   saveAs(blob, 'InventoryWithProfitLoss.xlsx');
//   return blob;
// };

// export default InventoryWithProfitLoss;

// InventoryWithProfitLoss.js
// reportsService.InventoryWithProfitLoss(recordset, data, mode)
//
// Uses XLSX (SheetJS) + file-saver, matching your TBUSDDataSourceExcel style.
// Built with aoa_to_sheet + manual !merges since json_to_sheet can't do
// grouped/2-layer headers on its own.

import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

// ---- Column definition (top group + sub columns) ----
// Edit widths/labels here only — everything else derives from this.
const reportColumns = [
  { headerText: 'Item Name', field: 'ProductName', width: 28 },
  { headerText: 'Opening', columns: [
      { headerText: 'Qty.', field: 'OpQuantity', width: 11 },
      { headerText: 'Rate', field: 'OpRate', width: 11 },
      { headerText: 'Amt.', field: 'OpAmount', width: 13 },
  ]},
  { headerText: 'Purchase', columns: [
      { headerText: 'Qty.', field: 'PurQuantity', width: 11 },
      { headerText: 'Rate', field: 'PurRate', width: 11 },
      { headerText: 'Amt.', field: 'PurAmount', width: 13 },
  ]},
  { headerText: 'Trans', columns: [
      { headerText: 'Qty.', field: 'TransQuantity', width: 11 },
  ]},
  { headerText: 'Available', columns: [
      { headerText: 'Qty.', field: 'AvailableQuantity', width: 11 },
      { headerText: 'Rate', field: 'AvailableRate', width: 11 },
      { headerText: 'Amt.', field: 'AvailableAmount', width: 13 },
  ]},
  { headerText: 'Closing Stock', columns: [
      { headerText: 'Qty.', field: 'ClosingQuantity', width: 11 },
      { headerText: 'Rate', field: 'ClosingRate', width: 11 },
      { headerText: 'Amt.', field: 'ClosingAmount', width: 13 },
  ]},
  { headerText: 'Sale', columns: [
      { headerText: 'Qty.', field: 'SaleQuantity', width: 11 },
      { headerText: 'Rate', field: 'SaleAvgRate', width: 11 },
      { headerText: 'Amt.', field: 'SaleAmount', width: 13 },
  ]},
  { headerText: 'Profit / Loss', columns: [
      { headerText: 'Rate', field: 'SaleRateDiff', width: 11 },
      { headerText: 'Amt.', field: 'profitLossAmt', width: 13 },
  ]},
];

// Flatten to the leaf (data-cell) columns, left to right
const leafColumns = reportColumns.flatMap((col) =>
  col.columns ? col.columns.map((c) => ({ ...c })) : [{ ...col }]
);
const TOTAL_COLS = leafColumns.length;

const numFmt = (val) => Number(val || 0);

// Build the two header rows (group row + sub row) as plain arrays,
// and return the merge ranges that go with them for a given row offset.
const buildHeaderRows = (rowOffset) => {
  const groupRow = new Array(TOTAL_COLS).fill('');
  const subRow = new Array(TOTAL_COLS).fill('');
  const merges = [];
  let col = 0;

  reportColumns.forEach((group) => {
    if (group.columns) {
      const start = col;
      const end = col + group.columns.length - 1;

      groupRow[start] = group.headerText;
      merges.push({ s: { r: rowOffset, c: start }, e: { r: rowOffset, c: end } });

      group.columns.forEach((sub, i) => {
        subRow[start + i] = sub.headerText;
      });
      col = end + 1;
    } else {
      // Single column (e.g. Item Name) spans both header rows
      groupRow[col] = group.headerText;
      merges.push({ s: { r: rowOffset, c: col }, e: { r: rowOffset + 1, c: col } });
      col += 1;
    }
  });

  return { groupRow, subRow, merges };
};

const InventoryWithProfitLoss = (recordset = [], data = {}, mode = 'download') => {
  const aoa = [];
  const merges = [];

  // ---- Row 0: From / To date ----
  aoa.push([`From Date : ${data.FromDate || ''}      To Date : ${data.ToDate || ''}`]);
  merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: TOTAL_COLS - 1 } });

  // ---- Row 1: Report title ----
  aoa.push(['Inventory With Profit / Loss']);
  merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: TOTAL_COLS - 1 } });

  // ---- Rows 2-3: two-layer column headers ----
  const { groupRow, subRow, merges: headerMerges } = buildHeaderRows(2);
  aoa.push(groupRow);
  aoa.push(subRow);
  merges.push(...headerMerges);

  const dataStartRow = aoa.length; // row index (0-based) where data begins

  // ---- Data rows ----
  recordset.forEach((item) => {
    const row = leafColumns.map((col) =>
      col.field === 'ProductName' ? (item[col.field] ?? '') : numFmt(item[col.field])
    );
    aoa.push(row);
  });

  // ---- Repeat the heading at the bottom, as requested ----
  aoa.push(new Array(TOTAL_COLS).fill('')); // blank spacer row
  const footerRowOffset = aoa.length;
  const { groupRow: footerGroup, subRow: footerSub, merges: footerMerges } = buildHeaderRows(footerRowOffset);
  aoa.push(footerGroup);
  aoa.push(footerSub);
  merges.push(...footerMerges);

  // ---- Build worksheet ----
  const worksheet = XLSX.utils.aoa_to_sheet(aoa);
  worksheet['!merges'] = merges;
  worksheet['!cols'] = leafColumns.map((c) => ({ wch: c.width || 13 }));
  // Keep the two header rows visible while scrolling through data
  worksheet['!freeze'] = { xSplit: 0, ySplit: dataStartRow };

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Inventory With P&L');

  if (mode !== 'download') {
    // e.g. called for preview / to feed another step — return the workbook itself
    return workbook;
  }

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, 'InventoryWithProfitLoss.xlsx');
  return blob;
};

export default InventoryWithProfitLoss;